import { AudioContextClock } from './AudioContextClock';
export class AudioElementClock extends AudioContextClock {
    audio;
    offset;
    _audioOffset;
    constructor(audio, audioContext, offset = 0) {
        super(audioContext);
        this.audio = audio;
        this.offset = offset;
        this._audioOffset = audioContext.currentTime;
    }
    get now() {
        if (this.audio.ended) {
            return this.audioContext.currentTime - this._audioOffset;
        }
        return this.audio.currentTime - this.offset;
    }
    async _seek(time) {
        this.audio.currentTime = time + this.offset;
        this._audioOffset = this.audioContext.currentTime - time;
        return super._seek(time);
    }
    async _resume() {
        if (this.audio.paused) {
            return this.audio.play().then(() => super._resume()).catch(() => this.now);
        }
        return super._resume();
    }
    timeAt(perfTime) {
        const now = this.now;
        if (this.isRunning) {
            const { performanceTime } = this.audioContext.getOutputTimestamp();
            const perfNow = performanceTime ?? performance.now();
            return now + (perfTime - perfNow) / 1000;
        }
        else {
            return now;
        }
    }
}
//# sourceMappingURL=AudioElementClock.js.map